import { useTranslation } from 'react-i18next';
import { Lock } from 'lucide-react';

import {
  Button,
  HamburgerButton,
  Label,
  Switch,
  TabsList,
  TabsTrigger,
} from '@app/shared/ui/atoms/Common';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@app/shared/ui/molecules/Common';
import { SortBy } from '@app/shared/types/pages/friends';

interface TopBarProps {
  isMenuOpen: boolean;
  toggleMenu: () => void;
  isTeam: boolean;
  onIsTeamChange: (value: boolean) => void;
  sortBy: string;
  onSortByChange: (value: string) => void;
}

export function TopBar({
  isMenuOpen,
  toggleMenu,
  isTeam,
  onIsTeamChange,
  sortBy,
  onSortByChange,
}: TopBarProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col">
      <div className="flex items-center">
        <TabsList>
          <TabsTrigger value="xp">{t('friends.xp')} 👁</TabsTrigger>
          {/*<TabsTrigger value="rank">{t('friends.xp')} 👁</TabsTrigger>*/}
          <TabsTrigger value="cookie">{t('friends.cookies')} 🍪</TabsTrigger>
          <TabsTrigger value="ton">TON 💎</TabsTrigger>
          <TabsTrigger value="clan" disabled>
            {t('friends.clans')} 🐼
            <Lock className="h-3 w-3 shrink-0" />
          </TabsTrigger>
        </TabsList>
        <HamburgerButton isOpen={isMenuOpen} onClick={toggleMenu} />
      </div>

      {isMenuOpen && (
        <div className="mt-[13px] flex items-center gap-1 px-4">
          <Label htmlFor="team-switch" className="text-xs">
            {t('friends.team')}
          </Label>
          <Switch id="team-switch" checked={isTeam} onCheckedChange={onIsTeamChange} />

          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button
                variant="custom"
                size="sm"
                className="rounded-[20px] bg-white px-5 py-[7px] text-xs font-medium text-white-foreground"
              >
                {t('friends.sort')}
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start" className="tracking-tight">
              <DropdownMenuRadioGroup value={sortBy} onValueChange={onSortByChange}>
                <DropdownMenuRadioItem value={SortBy.TOP100}>
                  <Label className="font-semibold">{t('friends.sort_top')}</Label>
                </DropdownMenuRadioItem>
                <DropdownMenuRadioItem value={SortBy.REGISTRATION_ASC}>
                  <div className="flex flex-col">
                    <Label className="font-semibold leading-none">
                      {t('friends.by_registration_date')}
                    </Label>
                    <Label className="font-semibold text-[#7a7a7a]">{t('friends.sort_new')}</Label>
                  </div>
                </DropdownMenuRadioItem>
                <DropdownMenuRadioItem value={SortBy.REGISTRATION_DESC}>
                  <div className="flex flex-col">
                    <Label className="font-semibold leading-none">
                      {t('friends.by_registration_date')}
                    </Label>
                    <Label className="font-semibold text-[#7a7a7a]">{t('friends.sort_old')}</Label>
                  </div>
                </DropdownMenuRadioItem>
              </DropdownMenuRadioGroup>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      )}
    </div>
  );
}
